import React, { Dispatch, SetStateAction } from 'react';
import Router from 'next/router';
import { Views } from '@/types/view';
import { Tabs, TabsList, TabsTrigger } from '@/components/shadcn/tabs';
import { useScout } from '@/hooks/useScout';
import { Button } from '@/components/shadcn/button';

export interface Props {
  setActiveView: Dispatch<SetStateAction<Views>>;
  page: string;
}

export default function ViewSelector({ setActiveView, page }: Props) {
  const defaultPage = page || Views.List;

  const { setLastSelectedView } = useScout();

  return (
    <div className="flex w-full justify-between">
      <Tabs value={defaultPage}>
        <TabsList>
          <TabsTrigger
            className="no-focus-ring"
            value={Views.List}
            onClick={() => {
              setActiveView(Views.List);
              setLastSelectedView(Views.List);
              Router.push(Views.List, undefined, { shallow: true });
            }}>
            List
          </TabsTrigger>
          <TabsTrigger
            className="no-focus-ring"
            value={Views.Location}
            onClick={() => {
              setActiveView(Views.Location);
              setLastSelectedView(Views.Location);
              Router.push(Views.Location, undefined, { shallow: true });
            }}>
            Locations
          </TabsTrigger>
          <TabsTrigger
            className="no-focus-ring"
            value={Views.Map}
            onClick={() => {
              setActiveView(Views.Map);
              setLastSelectedView(Views.Map);
              Router.push(Views.Map, undefined, { shallow: true });
            }}>
            Map
          </TabsTrigger>
        </TabsList>
      </Tabs>
      <Button
        className="bg-neutral-900 text-neutral-600"
        variant={'dark'}
        onClick={() =>
          Router.push('/scout/datasets', undefined, { shallow: true })
        }>
        See Available Datasets
      </Button>
    </div>
  );
}
